<template>
  <div class="wow-view">
    <div class="container vending-machine-checkout wrapper">
      <p class="has-text-centered has-top-margin">
        Vi har inga upplagda produkter som är tillräckligt häftiga för att visa.
        Kanske någon gång senare.
      </p>
      <br />
      <RouterLink
        :to="{ name: 'home' }"
        class="button is-info is-horizontal-middle"
        >Till startsidan</RouterLink
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "wow-view",
  components: {},
  data() {
    return {
      isLoading: true,
    };
  },
  async created() {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
